import React from 'react';

import '../stylesheet/suggest.css'
import MoviesCurosel from './Reusable/MoviesCurosel';


export default function Suggest({data}) {

  


  return (

    <div> 
      <h3 style={{ paddingTop:'20px', paddingLeft: '150px' }}>Recommended Movies</h3>
      <div> <MoviesCurosel data= {data}/> </div>
      
      <br/>

  
    </div>

   
  )
}
